<template>
    <HeaderAdmin></HeaderAdmin>
    <main>
        <section class="admin__container">
            <SideBar></SideBar>
            <RightContentWrapper>
                    <template #title>Account Details</template>
                    <template #desc>Here the place where you can change personal information, change Password & setup Address info</template>
                    <template #content><ProfileContent></ProfileContent></template>
            </RightContentWrapper>
        </section>
    </main>
</template>

<script>
import HeaderAdmin from '@/components/Header/HeaderAdmin.vue';
import SideBar from '@/components/UserGroups/Admins/SideBar.vue';
import RightContentWrapper from '@/components/UserGroups/Admins/RightContentWrapper.vue';
import ProfileContent from '@/components/UserGroups/Admins/ProfileContent.vue';
    export default {
        components: {
            HeaderAdmin,
            SideBar,
            RightContentWrapper,
            ProfileContent
        },
    }
</script>

<style lang="scss" scoped>

</style>